import * as yup from "yup"

export const validationSchema = yup.object().shape({
    mr_product_category_code: yup.string().label("Category code").required().test('len', 'Must be exactly 2 characters', val => val.toString().length === 2),
    mr_product_category_name: yup.string().label("Category name").required().max(100, "Must be 100 characters or less"),
    description: yup.string().label("Description").optional()
  })